"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import type { RatingStats } from "@/entities/IProfile";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { AuthContext } from "@/components/auth/Auth";
import Link from "next/link";
import { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
export default function UserPageRepModifyModalRaterStats(t0) {
  const $ = _c(30);
  const {
    repState,
    minMaxValues,
    heroAvailableCredit
  } = t0;
  const {
    activeProfileProxy
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== activeProfileProxy?.actions) {
    t1 = () => {
      const repProxy = activeProfileProxy?.actions.find(_temp);
      if (!repProxy) {
        return null;
      }
      return Math.max(0, (repProxy.credit_amount ?? 0) - (repProxy.credit_spent ?? 0));
    };
    $[0] = activeProfileProxy?.actions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getProxyAvailableCredit = t1;
  const [proxyAvailableCredit, setProxyAvailableCredit] = useState(getProxyAvailableCredit());
  let t2;
  if ($[2] !== getProxyAvailableCredit) {
    t2 = () => setProxyAvailableCredit(getProxyAvailableCredit());
    $[2] = getProxyAvailableCredit;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== activeProfileProxy) {
    t3 = [activeProfileProxy];
    $[4] = activeProfileProxy;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== activeProfileProxy || $[7] !== heroAvailableCredit || $[8] !== proxyAvailableCredit) {
    t4 = () => {
      if (!activeProfileProxy) {
        return heroAvailableCredit;
      }
      return Math.abs(heroAvailableCredit) < Math.abs(proxyAvailableCredit ?? 0) ? heroAvailableCredit : proxyAvailableCredit ?? 0;
    };
    $[6] = activeProfileProxy;
    $[7] = heroAvailableCredit;
    $[8] = proxyAvailableCredit;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const getAvailableCredit = t4;
  let t5;
  if ($[10] !== getAvailableCredit) {
    t5 = getAvailableCredit();
    $[10] = getAvailableCredit;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const [availableCredit, setAvailableCredit] = useState(t5);
  let t6;
  if ($[12] !== getAvailableCredit) {
    t6 = () => setAvailableCredit(getAvailableCredit());
    $[12] = getAvailableCredit;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== heroAvailableCredit || $[15] !== proxyAvailableCredit) {
    t7 = [heroAvailableCredit, proxyAvailableCredit];
    $[14] = heroAvailableCredit;
    $[15] = proxyAvailableCredit;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  useEffect(t6, t7);
  let t8;
  if ($[17] !== activeProfileProxy) {
    t8 = !!activeProfileProxy && <span className="tw-text-base tw-block tw-text-iron-300 tw-font-normal"><span>You are acting as proxy for:</span><span className="tw-ml-1 tw-font-semibold tw-text-iron-50"><Link href={`/${activeProfileProxy.created_by.handle}`}>{activeProfileProxy.created_by.handle}</Link></span></span>;
    $[17] = activeProfileProxy;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== activeProfileProxy || $[20] !== availableCredit) {
    t9 = !activeProfileProxy && <span className="tw-text-sm tw-block tw-text-iron-500 tw-font-medium"><span>Your available Rep:</span><span className="tw-ml-1 tw-font-semibold tw-text-iron-300">{formatNumberWithCommas(availableCredit)}</span></span>;
    $[19] = activeProfileProxy;
    $[20] = availableCredit;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== activeProfileProxy || $[23] !== minMaxValues || $[24] !== repState) {
    t10 = !activeProfileProxy && <span className="tw-text-sm tw-block tw-text-iron-500 tw-font-medium"><span>Your max/min Rep Rating to {repState.category}:</span><span className="tw-ml-1 tw-font-semibold tw-text-iron-300">+/- {formatNumberWithCommas(minMaxValues.max)}</span></span>;
    $[22] = activeProfileProxy;
    $[23] = minMaxValues;
    $[24] = repState;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t8 || $[28] !== t9) {
    t11 = <div className="tw-mt-6 sm:tw-mt-8"><div className="tw-flex tw-flex-col tw-space-y-1">{t8}{t9}{t10}</div></div>;
    $[26] = t10;
    $[27] = t8;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}
function _temp(action) {
  return action.action_type === ApiProfileProxyActionType.AllocateRep;
}